import React, { useState, useEffect, useCallback } from 'react'
import debounce from 'lodash/debounce' // Assurez-vous que lodash est installé
import styles from './GenericInput.module.css'

function GenericInput({ name, value, onChange }) {
  const [inputValue, setInputValue] = useState(value)

  // Mettre à jour l'état local lorsque la valeur globale change
  useEffect(() => {
    setInputValue(value)
  }, [value])

  // Fonction déclenchée après un délai pour limiter les mises à jour fréquentes
  const debouncedOnChange = useCallback(
    debounce((name, newValue) => {
      onChange({ target: { name, value: newValue } })
    }, 500), // Vous pouvez ajuster ce délai selon vos besoins
    []
  )

  // Gestionnaire d'événement pour chaque frappe de l'utilisateur
  const handleChange = useCallback(
    (event) => {
      setInputValue(event.target.value) // Mise à jour de l'état local
      debouncedOnChange(name, event.target.value) // Appel décalé de onChange
    },
    [name, debouncedOnChange]
  )

  return (
    <div className={styles.container}>
      <input
        type="text"
        name={name}
        value={inputValue}
        onChange={handleChange}
      />
    </div>
  )
}

export default GenericInput
